import { MasterDetailListEntry } from '@sdbn/common';
import { StationSet } from './station-set';

export class StationGroup implements MasterDetailListEntry {
    id: number;
    externalKey: string;
    name: string;
    description: string;
    stationSets: StationSet[] = [];

    constructor(stationGroup: Partial<StationGroup>) {
        this.id = stationGroup.id;
        this.externalKey = stationGroup.externalKey;
        this.name = stationGroup.name;
        this.description = stationGroup.description;
        if (stationGroup.stationSets != null) {
            for (const set of stationGroup.stationSets) {
                this.stationSets.push(new StationSet(set));
            }
        }
    }

    public get listTitle(): string {
        return this.name;
    }

    public get listTitleDictionaryKey(): string {
        return null;
    }

    public get listSubTitle(): string {
        return null;
    }

    public get groupIdentifier(): String {
      return null;
    }

    public get childs() : Array<MasterDetailListEntry> {
      return null;
    }
}
